import useSearchProducts from "@/Apollo/hooks/useSearchProducts";
import { SearchProductsByQueryItem } from "@/common/contracts/home.contracts";
import { useLanguage } from "@/common/hooks/pages.hooks";
import type { Language } from "@whoppah/apollo/schema";

/** Two desktop rows of six cards. */
const FOR_YOU_LIMIT = 6;
const NO_PRODUCTS: SearchProductsByQueryItem[] = [];

/**
 * The block's query variables. Exported so the homepage's "New this week" can read the same Apollo
 * cache entry (cache-only) to leave out what this block already shows.
 */
export const homepageForYouVariables = (language: Language) => ({
  input: {
    recommended: true,
    pagination: { limit: FOR_YOU_LIMIT },
  },
  lang: language,
});

export const useHomepageForYouProducts = () => {
  const { language } = useLanguage();

  const { data } = useSearchProducts({
    variables: homepageForYouVariables(language),
  });

  /* The gateway can return nulls in the list. Drop them here, so the block below can just render
   * a card for every item. */
  const products =
    data?.searchProducts?.items?.filter(
      (product): product is SearchProductsByQueryItem => !!product
    ) ?? NO_PRODUCTS;
  const searchMeta = {
    queryId: data?.searchProducts?.queryID ?? undefined,
    indexName: data?.searchProducts?.indexName ?? undefined,
    page: data?.searchProducts?.pagination?.page,
    limit: data?.searchProducts?.pagination?.limit,
  };

  return { products, searchMeta };
};
